import {
  endOfMonth,
  endOfWeek,
  format,
  isValid,
  parseISO,
  set,
  startOfMonth,
  startOfWeek,
} from "date-fns";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const key = "AIzaSyDDBwnxkNW6WlUrstIGtjJUuINSU8n1dbY";

export default function useSheets(props) {
  const match = useParams<{ community: string; wing?: string }>();
  const [events, setEvents] = useState([]);
  const view = props.view;
  const params = new URLSearchParams(window.location.search);
  // const isTest = params.get("test");
  // const isTest = true;
  // let spreadsheet = "1bwdvEe7WUqU9vr9y6qg2fXuPbdx6rd34Re7JHF41wRQ";
  let spreadsheet = "1loFF0TmGdwjkpRgcbeg8k6p4ipMsriMxdBoWQHDYoPs";
  spreadsheet = "14sGxCmEUXB1HPGTBvvrtZbpAPDWHmqYm4DYRDgoiSxY";

  // console.log("props.location", props.location);

  if (match.community === "fuquay") {
    if (match.wing === "c-wing" || props.location === "c-wing") {
      spreadsheet = "1LLbPUmG5sJ85kaGH2mrLPNwQIUmHNBVV2Y8Aepp77f0";
    } else {
      spreadsheet = "1D3J99VGVrADCGfjqcut1QXgf6whfEA4kKZTuRVtiP6U";
    }
  }

  if (match.community !== "fuquay") {
    if (props.location === "c-wing" || match.wing === "c-wing") {
      spreadsheet = "1WWDGB90mfsFOfR9EVDrobvDsM9sbAwFD57HSh2T2lLc";
    } else if (props.location === "b-wing" || match.wing === "b-wing") {
      spreadsheet = "1_WGUiEroVrWvRgHZHz86twYZkHBjYm3M5he_Ct8zcz8";
    }
  }

  if (match.community === "wakefield") {
    spreadsheet = "1jt7-ctfljRWNRQV8bQLgMH-dZIjTTkWsqKp-v1r9kZw";
    if (props.location === "c-wing" || match.wing === "c-wing") {
      spreadsheet = "162CiE60EBfF8nJm3PtlXZAOfjz5nsM3lAIwDA4N2bb4";
    }
  }

  if (match.community === "apex") {
    spreadsheet = "16SXBmmxxYJeY3L03HW4YBIfhnpF3XQbLwRED7PziVGc";
    if (props.location === "c-wing" || match.wing === "c-wing") {
      spreadsheet = "1CnRicFKMohCS22_a1kapilCMXIkbip4ZJbY_pg1qMHs";
    }
  }

  if (props.spreadsheet) {
    spreadsheet = props.spreadsheet;
  }

  // console.log("spreadsheet", spreadsheet);

  let today = new Date();

  if (params.get("date")) {
    const suppliedDate = parseISO(params.get("date"));
    suppliedDate.setHours(today.getHours(), today.getMinutes());
    today = suppliedDate;
  } else if (props.date) {
    today = props.date;
  }

  let range = format(today, "MMMM");

  if (props.range) {
    range = props.range;
  } else {
    range = format(today, "MMM yyyy");
  }

  // console.log("range", range);

  let startDate = today;
  let endDate;

  if (view === "week") {
    startDate = startOfWeek(today);
    endDate = endOfWeek(today);
  } else if (view === "month") {
    startDate = startOfMonth(today);
    endDate = endOfMonth(today);
  }

  function handleClientLoad() {
    // (window as any).gapi.load('client:auth2', initClient);
    (window as any).gapi.load("client", start);
  }

  function start() {
    (window as any).gapi.client
      .init({
        apiKey: key,
        discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
      })
      .then(() => {
        getSheets();
      });
  }

  async function getSheets() {
    if (import.meta.env.DEV && !props.spreadsheet && events.length > 0) {
      // console.log("events", events);
      return;
    }

    let res;

    try {
      res = await (window as any).gapi.client.sheets.spreadsheets.values.get({
        spreadsheetId: spreadsheet,
        range,
      });
    } catch (e) {
      console.log("e", e);
      setEvents([]);
      return;
    }

    const data = res.result;
    const keys = data.values[0];

    const result = [];

    const booleanKeys = [
      "Event-Highlight?",
      "Culinary-Highlight?",
      "Holiday?",
      "Hide on Monthly?",
      "Hide on Daily?",
      "Memory Care Calendar?",
    ];

    if (!props.spreadsheet) {
      for (const d of data.values) {
        const hasTime = d.find((i) => i.includes("AM") || i.includes("PM"));
        const hasTitle = d[4] || "—";
        const isHoliday = d[10] === "Yes";

        if ((hasTime && hasTitle) || isHoliday) {
          const item = {};
          const date = set(today, {
            date: parseInt(d[3] || 1),
          });

          if (!isValid(date)) {
            console.log("date", d);
            continue;
          }

          item["Day of Week"] = d[2];
          item["Event-Date"] = format(date, "M/d/yy");
          item["Event-Name"] = d[4].trim();
          item["Event-Start"] = d[5];
          item["Event-End"] = d[6];
          item["Event-Location"] = d[7];
          item["Event-Highlight?"] = d[8] === "Yes";
          item["Culinary-Highlight?"] = d[9] === "Yes";
          item["Holiday?"] = d[10] === "Yes";
          item["Hide on Monthly?"] = d[11] === "Yes";
          item["Hide on Daily?"] = d[12] === "Yes";
          item["Memory Care Calendar?"] = d[13] === "Yes";

          // if (item["Event-Name"]) {
          result.push(item);
          // }
        }
      }
    } else if (props.spreadsheet) {
      for (const d of data.values) {
        // console.log("d", d);

        if (d[6] === "No") {
          continue;
        }

        const item = {};

        item["Day of Week"] = d[2];
        item["Event-Name"] = d[3];
        item["Menu Items"] = d[4];

        if (d[5]) {
          result.push(item);
        }
      }
    } else {
      for (let itemIndex = 1; itemIndex < data.values.length; itemIndex++) {
        const item = {};

        for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
          let value = data.values[itemIndex][keyIndex];

          if (value === "yes") {
            value = true;
          } else if (booleanKeys.includes(keys[keyIndex]) && !value) {
            value = false;
          }

          item[keys[keyIndex]] = data.values[itemIndex][keyIndex];
        }

        result.push(item);
      }
    }

    // console.log("result", result);

    setEvents(result);

    if (import.meta.env.DEV) {
      localStorage.setItem("events", JSON.stringify(result));
    }
  }

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://apis.google.com/js/api.js`;
    script.onload = handleClientLoad;
    document.getElementsByTagName("head")[0].appendChild(script);

    if (import.meta.env.DEV && localStorage.getItem("events")) {
      const events = JSON.parse(localStorage.getItem("events"));
      setEvents(events);
    }
  }, []);

  // console.log("events", props.view, events);

  return {
    events,
    today,
    startDate,
    endDate,
  };
}
